import './dual-column-info.scss';

/**
 * version    1.0
 * class      <type> (Dual Column Info)
 */
export class DualColumnInfo {}
